import { useEffect, useState } from "react";

const STORAGE_KEY = "ch_gdpr_consent";

interface Consent {
  analytics: boolean;
  marketing: boolean;
  decided: boolean;
}

function loadConsent(): Consent | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function saveConsent(consent: Consent) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch { /* ignore */ }
}

export function GdprBanner() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);

  useEffect(() => {
    const saved = loadConsent();
    if (!saved?.decided) setVisible(true);
  }, []);

  function accept(all: boolean) {
    const consent: Consent = { analytics: all ? true : analytics, marketing: all ? true : marketing, decided: true };
    saveConsent(consent);
    setVisible(false);
    if (consent.marketing && typeof window !== "undefined" && (window as any).adsbygoogle) {
      try { ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({}); } catch { /* */ }
    }
  }

  if (!visible) return null;

  return (
    <div className="gdpr-banner" role="region" aria-label="Cookie consent">
      <div className="gdpr-inner">
        <div className="gdpr-text">
          <strong>We use cookies</strong>
          <p>
            United Calculator uses essential cookies to run the site. With your permission we also use analytics and advertising cookies to improve your experience and fund free calculators.{" "}
            <a href="/privacy-policy" className="gdpr-link">Privacy policy</a>
          </p>
        </div>

        {expanded && (
          <div className="gdpr-toggles">
            <label className="gdpr-toggle-row">
              <span>
                <strong>Essential</strong>
                <small>Required for the site to work. Cannot be disabled.</small>
              </span>
              <input type="checkbox" checked disabled readOnly />
            </label>
            <label className="gdpr-toggle-row">
              <span>
                <strong>Analytics</strong>
                <small>Help us understand how visitors use the site.</small>
              </span>
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
            </label>
            <label className="gdpr-toggle-row">
              <span>
                <strong>Marketing &amp; Ads</strong>
                <small>Used by Google AdSense to show relevant ads.</small>
              </span>
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
            </label>
          </div>
        )}

        <div className="gdpr-actions">
          {!expanded && (
            <button className="gdpr-btn gdpr-btn-ghost" onClick={() => setExpanded(true)}>
              Customise
            </button>
          )}
          {expanded && (
            <button className="gdpr-btn gdpr-btn-ghost" onClick={() => accept(false)}>
              Save preferences
            </button>
          )}
          <button className="gdpr-btn gdpr-btn-primary" onClick={() => accept(true)}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
